import { useEffect, useRef, useState } from "react";
import NorthStar from "./NorthStar";

export default function Cursor() {
  const dotRef = useRef(null);
  const [hovering, setHovering] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!fine) return;
    setEnabled(true);
    document.documentElement.classList.add("hide-native-cursor");

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const cur = { ...pos };
    let raf;

    const onMove = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      const t = e.target;
      setHovering(!!t.closest("a, button, [data-cursor='hover'], input, textarea, select"));
    };

    const loop = () => {
      cur.x += (pos.x - cur.x) * 0.18;
      cur.y += (pos.y - cur.y) * 0.18;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${cur.x}px, ${cur.y}px)`;
      }
      raf = requestAnimationFrame(loop);
    };
    loop();
    window.addEventListener("mousemove", onMove);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("hide-native-cursor");
    };
  }, []);

  if (!enabled) return null;

  return (
    <div ref={dotRef} className="cursor-dot">
      <div
        className="relative -translate-x-1/2 -translate-y-1/2 transition-transform duration-500 ease-out"
        style={{ transform: hovering ? "scale(2.4)" : "scale(1)" }}
      >
        <NorthStar className="w-3 h-3 text-warm" />
      </div>
    </div>
  );
}
